import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

export function deleteAuthFederationAdminRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.30',
    httpMethod: 'DELETE',
    endpoint: 'auth-federation/admin',
    serverWideRequest: false
  };
}

export function callDeleteAuthFederationAdminRequest(): Promise<void> {
  return makeJsonRestApiRequest<null, void>({
    config: deleteAuthFederationAdminRequestConfig(),
    request: null
  });
}
